import React, { PureComponent, memo } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { establecerParametros } from '../../store/parametros/actions';
import { Notificacion } from '../../components/Util/Notificacion/Notificacion';
import { Obtener_Empresas_Request, Obtener_CallCenter_Empresa_Request, ObtieneParametroSucursal } from '../../request/ParametroRequest';
import { Obtener_Sucursales_CallCenter_Request } from '../../request/SucursalRequest';
import { SiteRutas } from '../../request/RutasConfig';
import Select from '../../components/UI/Select/Select';
import Button from '../../components/UI/Button/Button';

class ParametrosPage extends PureComponent {
    _isMounted = false;
    state = {
        empresa: this.props.empresa,
        callCenter: this.props.callCenter,
        sucursal: this.props.sucursal,
        lstEmpresas: [{ Id: 0, Nombre: 'Seleccione una opción' }],
        lstCallCenters: [{ Id: 0, Nombre: 'Seleccione una opción' }],
        lstSucursales: [{ Id: 0, Nombre: 'Seleccione una opción', Cadena: 0 }],
        mapa: this.props.mapa
    }

    componentDidMount() {
        this._isMounted = true;
        if (this.props.usuarioLoguedo) {
            this.cargarEmpresas();
        }
        else {
            this.props.history.replace({ pathname: SiteRutas.Login });
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    cargarEmpresas = async () => {
        const response = await Obtener_Empresas_Request(this.props.token);
        if (response.Exitoso) {
            const lstEmpresas = [{ Id: 0, Nombre: 'Seleccione una opción' }, ...response.Datos];
            this.setState({ lstEmpresas }, () => {
                if (this.state.empresa && this.state.empresa.Id) {
                    this.cargarCallCenters(this.state.empresa.Id);
                }
            });
        }
        else {
            this.responseError(response);
        }
    }

    cargarCallCenters = async (pEmpresaId) => {
        if (pEmpresaId) {
            const response = await Obtener_CallCenter_Empresa_Request(this.props.token, pEmpresaId);
            if (response.Exitoso) {

                let lstCallCenters = [...response.Datos];
                if (lstCallCenters && lstCallCenters.length > 0) {
                    lstCallCenters.sort((a, b) => {
                        if (a.Nombre > b.Nombre) {
                            return 1;
                        }
                        if (a.name < b.Nombre) {
                            return -1;
                        }
                        return 0;
                    });
                }
                lstCallCenters.unshift({ Id: 0, Nombre: 'Seleccione una opción' });

                this.setState({ lstCallCenters }, () => {
                    if (this.state.callCenter && this.state.callCenter.Id) {
                        this.cargarSucursales(this.state.callCenter.Id);
                    }
                });
            }
            else {
                this.responseError(response);
            }
        }
    }

    cargarSucursales = async (pCallCenterId) => {
        if (this.state.empresa && this.state.empresa.Id && pCallCenterId) {
            const response = await Obtener_Sucursales_CallCenter_Request(this.props.token, this.state.empresa.Id, pCallCenterId);
            if (response.Exitoso) {
                const lstSucursales = [{ Id: 0, Nombre: 'Seleccione una opción', Cadena: 0 }, ...response.Datos];
                this.setState({ lstSucursales });
            }
            else {
                this.responseError(response);
            }
        }
    }

    responseError = pResponse => {
        Notificacion.error(pResponse.Mensaje);
        if (pResponse.CodigoError === 3) {
            this.props.history.push(SiteRutas.Login);
        }
    }

    onSelectChanged = event => {
        const { name, value, options, selectedIndex } = event.target;
        let valor = { Id: Number.parseInt(value), Nombre: options[selectedIndex].text };

        const defaultValor = { Id: 0, Nombre: 'Seleccione una opción' };
        const defaultOpcion = [defaultValor];

        switch (name) {
            case "empresa":
                this.setState({ [name]: valor, callCenter: defaultValor, sucursal: { ...defaultValor, Cadena: 0 }, lstCallCenters: defaultOpcion, lstSucursales: defaultOpcion }, () =>
                    this.cargarCallCenters(value)
                );
                break;
            case "callCenter":
                this.setState({ [name]: valor, sucursal: { ...defaultValor, Cadena: 0 }, lstSucursales: defaultOpcion }, () =>
                    this.cargarSucursales(value)
                );
                break;
            case "sucursal":
                const sucursalesFiltradas = valor.Id > 0 ? this.state.lstSucursales.filter(item => item.Id === valor.Id) : [{ Cadena: 0 }];
                valor.Cadena = sucursalesFiltradas[0].Cadena;

                this.setState({ [name]: valor });
                break;
            default:
                this.setState({ [name]: valor });
                break;
        }
    }

    onClickBtnSeleccionar = async event => {
        event.preventDefault();
        const { empresa, callCenter, sucursal } = this.state;
        const parametros = { empresa, callCenter, sucursal };
        if (this.validarParametros(parametros)) {

            parametros.mapa = { Llave: '', Longitud: '', Latitud: '' };

            if (sucursal && sucursal.Id > 0) {
                parametros.mapa.Longitud = await this.buscar_ParametroSucursal(empresa.Id, sucursal.Id, 'Longitud');
                parametros.mapa.Latitud = await this.buscar_ParametroSucursal(empresa.Id, sucursal.Id, 'Latitud');
            }

            this.props.establecerParametros(parametros);
            this.props.history.push(SiteRutas.Home);
        }
    }

    buscar_ParametroSucursal = async (pEmpresa, pSucursal, pNombre) => {
        if (this.props.token) {
            const response = await ObtieneParametroSucursal(this.props.token, pEmpresa, pSucursal, pNombre);
            if (response.Exitoso) {
                return response.Datos.valor.toString();
            }
            else {
                return 0;
            }
        }
    }

    validarParametros = pParametros => {

        if (!pParametros.empresa || pParametros.empresa.Id === 0) {
            Notificacion.error('Por favor seleccione una empresa.');
            return false;
        }

        return true;
    }

    render() {
        const { lstEmpresas, lstCallCenters, lstSucursales, empresa, callCenter, sucursal } = this.state;

        return (
            <div className="container mt-4">
                <div className="row">
                    <div className="col-md-12 text-center">
                        <h2>Parámetros</h2>
                    </div>
                </div>
                <div className="parametros">
                    <Select id="dllEmpresa"
                        name="empresa"
                        labelText="Empresa"
                        className="form-control"
                        classNameContainer="form-group"
                        value={empresa.Id}
                        onChange={this.onSelectChanged}
                        configuration={{ valueField: 'Id', textField: 'Nombre', options: lstEmpresas }} />

                    <Select id="ddlCallCenter"
                        name="callCenter"
                        labelText="Call Center"
                        className="form-control"
                        classNameContainer="form-group"
                        value={callCenter.Id}
                        onChange={this.onSelectChanged}
                        configuration={{ valueField: 'Id', textField: 'Nombre', options: lstCallCenters }} />

                    <Select id="dllSucursal"
                        name="sucursal"
                        labelText="Sucursal"
                        className="form-control"
                        classNameContainer="form-group"
                        value={sucursal.Id}
                        onChange={this.onSelectChanged}
                        configuration={{ valueField: 'Id', textField: 'Nombre', options: lstSucursales }} />

                    <div className="text-right">
                        <Button text="Seleccionar" className="btn-aceptar" onClick={this.onClickBtnSeleccionar} />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        token: state.usuario.token,
        usuarioLoguedo: state.usuario.usuarioLoguedo,
        empresa: state.parametros.empresa,
        sucursal: state.parametros.sucursal,
        callCenter: state.parametros.callCenter,
        mapa: state.parametros.mapa
    };
};

export default connect(mapStateToProps, { establecerParametros })(withRouter(memo(ParametrosPage)));